import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink, Outlet } from 'react-router-dom';
import { Grid, Menu } from 'semantic-ui-react';

const Billing = () => {
    const hasOutstandingInvoices = useSelector(state => state.auth.company_status === 'paused');
    return (
        <Grid>
            <Grid.Row>
                <Grid.Column>
                    <Menu borderless pointing secondary color='primary' stackable>
                        <Menu.Item as={NavLink} name='Overview' to={`overview`} />
                        <Menu.Item disabled={hasOutstandingInvoices} as={NavLink} name='Transaction History' to={`transaction-history`} />
                        <Menu.Item disabled={hasOutstandingInvoices} as={NavLink} name='Payment Method' to={`payment-method`} />
                        <Menu.Item disabled={hasOutstandingInvoices} as={NavLink} name='Billing Contacts' to={`billing-contacts`} />
                    </Menu>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column>
                    <Outlet />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}

export default Billing;
